import { api } from "../../api_client";
import { useApi } from "../../../swr/useApi";

export type StateDto = {
  id: number;
  name: string;
  country?: {
    id: number;
    name: string;
  } | null;
};

export function useStates(countryId?: string | null) {
  const key = `states-${countryId ?? "all"}`;

  return useApi<StateDto[]>(
    key,
    async () =>
      await api.get("/api/v1/states", {
        params: countryId ? { countryId: Number.parseInt(countryId, 10) } : undefined,
      }),
  );
}
